let lenis = null;

export const setLenis = (instance) => {
  lenis = instance;
};

export const scrollToTop = () => {
  if (lenis) lenis.scrollTo(0, { immediate: true });
  else window.scrollTo(0, 0);
};

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (lenis) {
    lenis.resize();
    lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  } else el.scrollIntoView({ behavior: "auto", block: "start" });
  if (!el.hasAttribute("tabindex")) el.setAttribute("tabindex", "-1");
  el.focus({ preventScroll: true });
};

export const setContactTopic = (topic) => {
  window.dispatchEvent(new CustomEvent("sss:topic", { detail: topic }));
};
